import { axios } from '@Root/API'

export const getStatic = (engagementId, params) => {
	return axios.get(`get-data-accreditation-aim`, { params })
}
